<template>
  <v-dialog
    v-model="show"
    :fullscreen="true"
    transition="dialog-bottom-transition"
    scrollable
  >
    <v-card>
      <v-toolbar
        dense
        flat
        dark
        color="#444444"
      >
        <div>Medical Record Viewer</div>
        <v-spacer></v-spacer>
        <v-btn
          icon
          @click="onClose"
          dark
        >
          <v-icon>close</v-icon>
        </v-btn>
      </v-toolbar>

      <v-layout
        fill-height
        column
        justify-center
      >
        <iframe
          style="width:100%; height:100%; overflow:hidden"
          :src="this.options.fileLocation"
          frameborder="0"
        ></iframe>
      </v-layout>

    </v-card>
  </v-dialog>
</template>

<style lang="scss" scoped>
$primaryColor: #1565c0;
$default: #666;
$no-items: #a9a9a9;

.-webkit-scrollbar {
  display: none;
}
</style>

.search-field {
  background: #f5f5f5;
  border-radius: 4px;
  padding-left: 18px;
}

<script>
import DialogMixin from '@/core/mixins/DialogMixin'
import pdf from 'vue-pdf'
import bus from '@/core/helpers/bus'
import DownloadImagesDialog from '@/components/dialogs/DownloadImagesDialog'

export default {
  name: 'OneFileDialog',
  mixins: [DialogMixin],
  components: {
    pdf,
    DownloadImagesDialog
  },
  data() {
    return {
      defaultOptions: {
        okLabel: 'Confirm',
        cancelLabel: 'Cancel',
        showOk: true,
        showCancel: false
      },
      isOpen: false,
      revealPDF: false,
      src: undefined,
      numPages: undefined,
      loaded: false,
      showPDF: false,
      isPDF: false
    }
  },
  props: {
    imageSet: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    source() {
      let url =
        this.options.file.downloadURL +
        '?alt=media&token=' +
        this.options.file.accessToken
      let fileUrl =
        process.env.PDF_VIEWER_URL + '?file=' + encodeURIComponent(url)
      if (this.options.currentPage) {
        fileUrl += '#page=' + this.options.currentPage
      }
      // TODO: Emit the file URL
      return fileUrl
    },
    isDesktop() {
      return this.$vuetify.breakpoint.smAndUp
    }
  },
  watch: {
    loaded() {
      this.displayRecord()
    }
  },
  methods: {
    onOpen() {
      this.isOpen = true
      this.showPDF = false
      this.loaded = false
      console.log('the url that has been submitted')
      console.log(this.options.fileLocation)

      switch (this.options.file.mimetype) {
        case 'application/pdf':
          this.isPDF = true
          this.loadThePDF()
          break
      }
    },
    error: function(err) {
      console.log(err)
    },
    loadingTask() {
      return pdf.createLoadingTask(
        this.options.file.downloadURL +
          '?alt=media&token=' +
          this.options.file.accessToken
      )
    },
    loadThePDF() {
      this.src = this.loadingTask()
      this.src.then(pdf => {
        this.numPages = pdf.numPages
        this.loaded = true
      })
    },
    displayRecord() {
      if (this.isOpen) {
        if (this.isPDF) {
          this.showPDF = true
        }
      }
    },
    onClose() {
      this.isOpen = false
      this.revealPDF = false
      this.loaded = false
      this.showPDF = false
      this.isPDF = false
      this.cancel()
    },
    download() {
      window.open(
        this.options.file.downloadURL +
          '?alt=media&token=' +
          this.options.file.accessToken
      )
    },
    showDownloadDialog() {
      let forwardedImages = this.options.imageSet
      this.$refs.downloadImagesDialog.open({
        forwardedImages
      })
    },
    getfileURL() {
      const vm = this
      console.log('#PROCESS', process.env.PDF_VIEWER_URL)
      console.log(
        '#URL',
        this.options.file.downloadURL +
          '?alt=media&token=' +
          this.options.file.accessToken
      )

      const url =
        this.options.file.downloadURL +
        '?alt=media&token=' +
        this.options.file.accessToken

      switch (vm.options.file.mimetype) {
        case 'application/pdf':
          console.log(
            process.env.PDF_VIEWER_URL + '?file=' + encodeURIComponent(url)
          )
          return process.env.PDF_VIEWER_URL + '?file=' + encodeURIComponent(url)
      }
    },
    goToPagePDF() {}
  },
  created() {
    this.goToPagePDF()
    bus.$on('page-loaded', () => {
      this.loaded = true
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/dialogs/FileDialog.vue